import { MatDialog } from "@angular/material/dialog";
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChildren, } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { BehaviorSubject, Observable, Subject, } from "rxjs";
import { NotificationService } from "src/app/core/services/notification.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { AbstractControl, FormControl, FormGroup, FormGroupDirective, NgForm, ValidationErrors, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { GeneralCategory } from "src/app/shared/models/general-category.model";
import { ErrorCode } from "src/app/core/constants/error-code";
import { MenuExportReportService } from "src/app/core/services/menu-export-report.service";
import { TranslateService } from "@ngx-translate/core";
import { EmplomentContractService } from "src/app/core/services/employment-contract.service";
import { ErrorStateMatcher, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
export class InstantErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.touched || isSubmitted));
  }
}
@Component({
  selector: 'app-list-report',
  templateUrl: './list-report.component.html',
  styleUrls: ['./list-report.component.scss'],
  providers: [
    { provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher }
  ]
})
export class ListReportComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("focusInput") focusInput;
  today: Date = new Date();
  searchForm: FormGroup;
  listDataSource: MenuExportReportDataSource;
  matcher = new InstantErrorStateMatcher();
  displayedColumns = [
    'stt',
    'name',
    'reportPeriod',
    'reportYear',
    'dateRange',
    'reportDate',
    'contractCount',
    'createdTime',
    'exportStatus',
    'signStatus',
    'sendMohaStatus',
    'action'
  ];

  conditionSearch = {
    reportName: "",
    exportStatus: null,
    signStatus: null,
    sendMohaStatus: null,
    createdFromDate: this.getMinus31Days(this.today),
    createdToDate: new Date(),

    page: 0,
    pageSize: 10,
  };

  valueSelect: any;

  paginate = {
    currentPage: 0,
    pageSize: 10,
    totalRow: 0,
    totalPage: 0,
    totalPageArray: [],
    no: [],
  };

  listStatus: any = [
    { labelKey: "menu_export_report.status_select.all_status", value: null },
    { labelKey: "menu_export_report.status_select.inprogress", value: 2 },
    { labelKey: "menu_export_report.status_select.success", value: 4 },
    { labelKey: "menu_export_report.status_select.fail", value: 3 },
  ];
  
  listSignatureStatus: any = [
    { labelKey: "menu_export_report.status_select.all_status", value: null },
    { labelKey: "menu_export_report.status_select.unsigned", value: 1 },
    { labelKey: "menu_export_report.status_select.inprogress", value: 2 },
    { labelKey: "menu_export_report.status_select.completed", value: 4 },
    { labelKey: "menu_export_report.status_select.fail", value: 3 },
  ];
  
  listSendStatus: any = [
    { labelKey: "menu_export_report.status_select.all_status", value: null },
    { labelKey: "menu_export_report.status_select.unsended", value: 1 },
    { labelKey: "menu_export_report.status_select.sending", value: 2 },
    { labelKey: "menu_export_report.status_select.completed", value: 4 },
    { labelKey: "menu_export_report.status_select.fail", value: 3 },
  ];

  loadingSearch: boolean = false;
  _onDestroy = new Subject<void>();
  lastTouchedField: string = '';
  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private menuExportReportService: MenuExportReportService,
    private emplomentContractService: EmplomentContractService
  ) {
    super(commonService, message);
    this.notifier = notifier;
    const now = new Date();
    const createdFromDate = this.getMinus31Days(now);
    this.route.queryParams.subscribe((queryparams) => {
      this.conditionSearch = {
        reportName: queryparams.reportName ? queryparams.reportName : null,
        exportStatus: queryparams.exportStatus ? queryparams.exportStatus : null,
        signStatus: queryparams.signStatus ? queryparams.signStatus : null,
        sendMohaStatus: (queryparams.sendMohaStatus || queryparams.sendMohaStatus == 0) ? Number(queryparams.sendMohaStatus) : null,
        createdFromDate: queryparams.createdFromDate ? new Date(queryparams.createdFromDate) : createdFromDate,
        createdToDate: queryparams.createdToDate ? new Date(queryparams.createdToDate) : new Date(),
        page: queryparams.page ? Number(queryparams.page) : 0,
        pageSize: queryparams.pageSize ? Number(queryparams.pageSize) : 10,
      };
    });
  }
  decodeId(id: string): string {
    if (!id) return '';
    try {
      return atob(id);
    } catch (e) {
      return id;
    }
  }
  getMinus31Days(toDate: Date | string): Date {
    const d = toDate ? new Date(toDate) : new Date();
    if (isNaN(d.getTime())) return new Date();
    d.setDate(d.getDate() - 31);
    return d;
  }
  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    if (isNaN(d.getTime())) return '';
    const month = '' + (d.getMonth() + 1);
    const day = '' + d.getDate();
    const year = d.getFullYear();

    return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
  }
  cleanParams(obj: any) {
    const newObj: any = {};
    Object.keys(obj).forEach((key) => {
      if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
        newObj[key] = obj[key];
      }
    });
    return newObj;
  }
  isFirstLoad = true;
  ngOnInit() {
    const now = new Date();
    const createdFromDate = this.getMinus31Days(now);
    this.searchForm = new FormGroup({
      reportName: new FormControl(null, [Validators.maxLength(255)]),
      exportStatus: new FormControl(null),
      signStatus: new FormControl(null),
      sendMohaStatus: new FormControl(null),
      createdFromDate: new FormControl(createdFromDate, [Validators.required]),
      createdToDate: new FormControl(now, [Validators.required]),
    }, { validators: this.dateRangeValidator.bind(this) });
    this.searchForm.patchValue(this.conditionSearch)
    this.listDataSource = new MenuExportReportDataSource();
    this.loadData(this.conditionSearch);
    this.notificationService.subscribeErrorService();
    window.scrollTo(0, 0);
    this.route.queryParams.subscribe((params) => {
      if (params && Object.keys(params).length > 0) {
        const formattedParams: any = { ...params };

        if (params.exportStatus) formattedParams.exportStatus = Number(params.exportStatus);
        if (params.signStatus) formattedParams.signStatus = Number(params.signStatus);
        if (params.sendMohaStatus) formattedParams.sendMohaStatus = Number(params.sendMohaStatus);

        if (params.createdFromDate) formattedParams.createdFromDate = new Date(params.createdFromDate);
        if (params.createdToDate) formattedParams.createdToDate = new Date(params.createdToDate);

        this.searchForm.patchValue(formattedParams, { emitEvent: false });
      }

      this.loadData(params);
    });
  }
  dateRangeValidator(group: FormGroup) {
    const fromCtrl = group.controls['createdFromDate'];
    const toCtrl = group.controls['createdToDate'];
  
    if (!fromCtrl || !toCtrl || !fromCtrl.value || !toCtrl.value) {
      return null;
    }
  
    const fromDate = new Date(fromCtrl.value);
    const toDate = new Date(toCtrl.value);
    fromDate.setHours(0, 0, 0, 0);
    toDate.setHours(0, 0, 0, 0);
  
    if (fromDate > toDate) {
      if (this.lastTouchedField === 'createdToDate') {
        toCtrl.setErrors({ ...toCtrl.errors, dateRangeInvalid: true });
        this.clearControlError(fromCtrl, 'dateRangeInvalid');
      } else {
        fromCtrl.setErrors({ ...fromCtrl.errors, dateRangeInvalid: true });
        this.clearControlError(toCtrl, 'dateRangeInvalid');
      }
    } else {
      this.clearControlError(fromCtrl, 'dateRangeInvalid');
      this.clearControlError(toCtrl, 'dateRangeInvalid');
    }
  
    return null;
  }
  clearDateRangeError(control: AbstractControl) {
    if (control && control.hasError('dateRangeInvalid')) {
      delete control.errors['dateRangeInvalid'];
      if (!Object.keys(control.errors).length) {
        control.setErrors(null);
      }
    }
  }
  ngAfterViewInit() {
    setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.notificationService.subscribeErrorService();
  }

  loadData(request: any) {
    if (this.searchForm) {
      const fromControl = this.searchForm.get('createdFromDate');
      const toControl = this.searchForm.get('createdToDate');
  
      if (fromControl) fromControl.markAsTouched();
      if (toControl) toControl.markAsTouched();
  
      if (this.searchForm.invalid || (fromControl && fromControl.invalid) || (toControl && toControl.invalid)) {
        return; 
      }
    }
    const formVal = this.searchForm ? this.searchForm.value : {};

    const rawFromDate = formVal.fromDate || request.createdFromDate || this.conditionSearch.createdFromDate;
    const rawToDate = formVal.toDate || request.createdToDate || this.conditionSearch.createdToDate;

    let rawParams = {
      reportName: formVal.reportName || request.reportName || null,
      sendMohaStatus: formVal.sendMohaStatus !== null && formVal.sendMohaStatus !== undefined
        ? formVal.sendMohaStatus
        : (request.sendMohaStatus ? true : (request.sendMohaStatus == 0 ? false : null)),
      exportStatus: formVal.exportStatus !== null && formVal.exportStatus !== undefined
        ? formVal.exportStatus
        : (request.exportStatus ? true : (request.exportStatus == 0 ? false : null)),
      signStatus: formVal.signStatus !== null && formVal.signStatus !== undefined
        ? formVal.signStatus
        : (request.signStatus ? true : (request.signStatus == 0 ? false : null)),

      createdFromDate: this.formatDate(rawFromDate),
      createdToDate: this.formatDate(rawToDate),

      page: request.page || 0,
      pageSize: request.pageSize || 10
    };

    const cleanBody = this.cleanParams(rawParams);


    this.emplomentContractService.getAllSearch(cleanBody).subscribe((res: any) => {
      if (!res || !res.success) {
        console.warn('API trả về lỗi:', res && res.message);
        this.listDataSource.setData([]);
        return;
      }

      const rawData = (res.data && res.data.dataRow) || (res.data && res.data.content) || res.data || [];

      if (Array.isArray(rawData)) {
        const listData = rawData.map((item: any) => ({
          ...item,
          id: item.id,
          decodedId: this.decodeId(item.id)
        }));

        console.log('=== DỮ LIỆU ĐÃ GIẢI MÃ (DECODED) ===', listData);

        this.listDataSource.setData(listData);
        this.paginate = {
          currentPage: res.data.currentPage,
          pageSize: res.data.pageSize,
          totalRow: res.data.totalRow,
          totalPage: Math.ceil(res.data.totalRow / res.data.pageSize),
          totalPageArray: this.commonService.counter(
            Math.ceil(res.data.totalRow / res.data.pageSize),
            1
          ),
          no: this.commonService.counter(
            res.data.pageSize,
            res.data.currentPage * res.data.pageSize + 1
          ),
        };
      } else {
        this.listDataSource.setData([]);
      }
    });
  }

  onClickBtnFilter() {
    const controls = this.searchForm.controls
    this.conditionSearch.reportName = controls.reportName.value
      ? controls.reportName.value
      : null;
    this.conditionSearch.signStatus = controls.signStatus.value
      ? controls.signStatus.value
      : null;
    this.conditionSearch.exportStatus = controls.exportStatus.value
      ? controls.exportStatus.value
      : null;
    this.conditionSearch.sendMohaStatus = (controls.sendMohaStatus.value || controls.sendMohaStatus.value == 0)
      ? controls.sendMohaStatus.value
      : null;
    this.conditionSearch.createdFromDate = controls.createdFromDate.value
      ? controls.createdFromDate.value
      : null;
    this.conditionSearch.createdToDate = controls.createdToDate.value
      ? controls.createdToDate.value
      : null;


    console.log(this.conditionSearch.createdFromDate);
    console.log(this.conditionSearch.createdToDate);

    this.conditionSearch.page = 0;
    this.conditionSearch.pageSize = 10;
    this.loadData(this.conditionSearch)
  }

  clearData(field: string) {
    this.searchForm.get(field).patchValue(null);
  }

  shouldShowCopyButton(element: any): boolean {
    if (!element) return false;

    const isExportValid = element.exportStatusCode === 2 || element.exportStatusCode === 3;

    const isSignValid = element.signStatusCode === 2 || element.signStatusCode === 4;
    const isSendMohaValid = element.sendMohaStatusCode === 2 || element.sendMohaStatusCode === 4;

    return isExportValid || (isSignValid && isSendMohaValid);
  }
  formatParamsForUrl(params: any): any {
    const formatted = { ...params };

    Object.keys(formatted).forEach(key => {
      const value = formatted[key];

      if (value instanceof Date) {
        const day = String(value.getDate()).padStart(2, '0');
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const year = value.getFullYear();

        formatted[key] = `${year}-${month}-${day}`; 
      }
    });

    return formatted;
  }

  onPageChange(page: number = 0, pageSize: number = 10) {
    this.paginate = {
      ...this.paginate,
      currentPage: page,
      pageSize,
    };

    const rawFormValue = this.searchForm.value;
    const cleanQueryParams = this.formatParamsForUrl({
      ...rawFormValue,
      page: this.paginate.currentPage,
      pageSize: this.paginate.pageSize
    });

    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: cleanQueryParams,
      replaceUrl: true,
    });
  }
  onDownload(element: any) {
    if (!element || !element.id) return;
  
    this.menuExportReportService.downloadReportFile(element.id).subscribe(
      (res: any) => {
        // Log toàn bộ res ra Console để kiểm tra xem có res.headers không
        console.log('Response từ server:', res);
  
        const rawBlob = (res && res.body) ? res.body : res;
        if (!rawBlob) return;
  
        let fileName = 'bao-cao.pdf';
  
        // Đọc header an toàn
        let contentDisposition = null;
        if (res && res.headers && typeof res.headers.get === 'function') {
          contentDisposition = res.headers.get('content-disposition') || res.headers.get('Content-Disposition');
        }
  
        console.log('Header Content-Disposition lấy được:', contentDisposition);
  
        if (contentDisposition) {
          // Tách lấy phần chuỗi filename*=UTF-8''... hoặc filename="..."
          const matches = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition) || 
                          /filename="?([^";]+)"?/i.exec(contentDisposition);
          if (matches && matches[1]) {
            try {
              fileName = decodeURIComponent(matches[1]);
            } catch (e) {
              fileName = matches[1];
            }
          }
        }
  
        // Thực hiện download file
        const blob = new Blob([rawBlob], { type: rawBlob.type || 'application/pdf' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
  
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      },
      (err: any) => {
        this.toast.error(
          this.message.getMessage('messages.delete_labor_report_found_error')
        );
      }
    );
  }
  async deleteReport(element) {
    const dataDialog = this.commonService.format(
      this.message.getMessage("messages.confirm_delete_menu_report"),
      element.reportName
    );
    const warnDialog = this.dialog.open(WarningComponent, {
      // width: "40%",
      data: dataDialog,
    });
    warnDialog.afterClosed().subscribe(async (res) => {
      if (res) {
        this.menuExportReportService
          .deleteReport(element.id)
          .subscribe((res) => {
            if (res && res.code === ErrorCode.NotPermissionTemplate) {
              this.toast.error(this.message.getMessage('messages.check_permission'));
              return;
            }
            this.toast.success(
              this.message.getMessage(
                'messages.delete_menu_report_success'
              )
            );
            if (this.paginate.totalRow % this.paginate.pageSize === 1 && this.paginate.currentPage === this.paginate.totalPage - 1) {
              this.conditionSearch.pageSize = this.paginate.pageSize;
              this.conditionSearch.page = this.paginate.currentPage ? this.paginate.currentPage - 1 : 0;
            }
            this.loadData(this.conditionSearch);
          });
      }
    });
  }
  onClickCreate() {
    this.router.navigateByUrl("/home-enterprise/menu-export-report/create");
  }

  viewReport(id: any): void {
    this.router.navigate(['/home-enterprise/menu-export-report/view', id, true]);
  }
  copyReport(id: any): void {
    this.router.navigate(['/home-enterprise/menu-export-report/create', id]);
  }
  focusOut(field: string) {
    const value = this.searchForm.get(field).value
      ? this.searchForm.get(field).value.trim()
      : null;
    this.searchForm.get(field).patchValue(value);
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName("cell");

    if (elmsSpan.item(index).scrollWidth > elmsCell.item(index).scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  displayTooltipForDes(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCellDes = document.getElementsByClassName("cellDes");

    if (elmsSpan.item(index) && elmsCellDes.item(index) && (elmsSpan.item(index).scrollWidth > elmsCellDes.item(index).scrollWidth)) {
      return data;
    } else {
      return null;
    }
  }

  formatDateString(value: string): string {
    if (!value) return '';
    const cleanValue = value.replace(/\D/g, ''); // Chỉ lấy chữ số
    if (cleanValue.length === 8) {
      const day = cleanValue.substring(0, 2);
      const month = cleanValue.substring(2, 4);
      const year = cleanValue.substring(4, 8);
      return `${day}/${month}/${year}`;
    }
    return value.trim();
  }

  // Bỏ câu lệnh control.setErrors(null) ở dòng 554.
  // Hàm onDateInputChange chỉ cần xử lý đơn giản như sau:

  clearControlError(control: AbstractControl | null, errorName: string): void {
    if (control && control.hasError(errorName)) {
      delete control.errors![errorName];
      if (!Object.keys(control.errors!).length) {
        control.setErrors(null);
      }
    }
  }
  
  onDateInputChange(fieldName: string, inputElem: HTMLInputElement, control: AbstractControl) {
    this.lastTouchedField = fieldName;
  
    if (control) {
      control.markAsTouched();
    }
  
    let rawValue = inputElem.value;
    const formattedValue = this.formatDateString(rawValue);
    inputElem.value = formattedValue;
  
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
  
    if (formattedValue && regex.test(formattedValue)) {
      const [day, month, year] = formattedValue.split('/').map(Number);
      const dateObj = new Date(year, month - 1, day);
  
      if (dateObj.getFullYear() === year && dateObj.getMonth() === month - 1 && dateObj.getDate() === day) {
        control.setValue(dateObj);
      } else {
        control.setValue(null);
      }
    } else {
      control.setValue(null);
    }
  
    this.commonService.resetDatePicker(inputElem.value, control);
  
    // Trigger lại validation độc lập cho CẢ HAI control
    const createdFromCtrl = this.searchForm.get('createdFromDate');
    const createdToCtrl = this.searchForm.get('createdToDate');
  
    if (createdFromCtrl) {
      createdFromCtrl.updateValueAndValidity({ emitEvent: false });
    }
    if (createdToCtrl) {
      createdToCtrl.updateValueAndValidity({ emitEvent: false });
    }
  
  }
  getErrorDateMessageV2(pickerInput: string, isExpired: boolean = false, nameField: string): string {
    const control = this.searchForm.controls[nameField];
    if (!pickerInput || pickerInput.trim() === '') {
      if (nameField === 'createdFromDate') {
        return this.message.getMessage('menu_export_report.created_from_date_required');
      }
      if (nameField === 'createdToDate') {
        return this.message.getMessage('menu_export_report.created_to_date_required');
      }
    }
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
    if (!regex.test(pickerInput)) {
      return this.message.getMessage('validation.format_of_date');
    }
  
    const [day, month, year] = pickerInput.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const isValid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  
    if (!isValid) {
      return this.message.getMessage('validation.format_of_date');
    }
  
    // 3. Validate không cho chọn ngày tương lai
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    if (date > today) {
      const fieldNameStr = nameField === 'createdFromDate'
        ? this.message.getMessage('menu_export_report.initialized_from_date')
        : this.message.getMessage('menu_export_report.initialized_to_date');
      return this.message.getMessage('menu_export_report.validation.future_date_not_allowed').replace('{0}', fieldNameStr);
    }
    if (control && control.hasError('dateRangeInvalid')) {
      if (nameField === this.lastTouchedField) {
        if (nameField === 'createdFromDate') {
          return this.message.getMessage('menu_export_report.from_date_greater_than_to_date');
        }
        if (nameField === 'createdToDate') {
          return this.message.getMessage('menu_export_report.to_date_greater_than_from_date');
        }
      }
    }
  
    return '';
  }
}

export class MenuExportReportDataSource extends DataSource<GeneralCategory> {
  /** Stream of data that is provided to the table. */
  private data = new BehaviorSubject<GeneralCategory[]>([]);
  private loading = new BehaviorSubject<boolean>(false);

  public loading$ = this.loading.asObservable();

  constructor() {
    super();
  }

  // indicate is loading
  startLoadData() {
    this.loading.next(true);
  }

  setData(data: GeneralCategory[]) {
    this.data.next(data);
    this.loading.complete();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<GeneralCategory[]> {
    return this.data.asObservable();
  }

  /* disconnect() {} */
  disconnect(): void {
    this.data.complete();
    this.loading.complete();
  }

}
